<div class="grid">
  <div class="loading-spinner" *ngIf="isLoading">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>
  <ng-container *ngIf="!isLoading">
    <div class="col-12" *ngFor="let item of items">
      <div class="area-header">
        <h3>{{ item[titleField] | capitalize }}</h3>
        <div class="button-group">
          <button
            pButton
            icon="pi pi-plus-circle"
            class="p-button-rounded p-button-text"
            (click)="onAddClick(item)"
          ></button>
          <button
            pButton
            icon="pi pi-pencil"
            class="p-button-rounded p-button-text"
            (click)="onEditClick(item)"
          ></button>
        </div>
      </div>

      <p-card styleClass="h-full">
        <div *ngFor="let subitem of item[sublistField]" class="job-item">
          <div class="job-content">
            <i class="pi pi-user"></i>
            <span>{{ subitem[subitemField] | capitalize }}</span>
          </div>
          <button
            pButton
            icon="pi pi-pencil"
            class="p-button-rounded p-button-text"
            (click)="onSubitemEditClick(item, subitem)"
          ></button>
        </div>
      </p-card>
    </div>
  </ng-container>
</div>